export const isFn = (value: any): value is Function => {
  return typeof value === "function"
}
